module.exports = __webpack_public_path__ + "static/img/bg.9049d36d.png";